import { EXCLUDE_NAVBAR, EXCLUDE_SIDEBAR, ProtectedRoute, LoggedInRoute } from "./App";
import { Switch, Route } from "react-router-dom";
import { MiniDashboardNavbar } from "./components/MiniDashboardNavbar";
import { Banner } from "./components/Banner";
import { LandingPage } from "./pages/marketing/LandingPage";
import LoginPage from "./pages/dashboard/Login";
import RequestResetPasswordPage from "./pages/dashboard/RequestResetPassword";
import SignUpPage from "./pages/dashboard/SignUp";
import PasswordResetPage from "./pages/dashboard/PasswordReset";
import MiniDashboardChatbot from "./pages/mini-dashboard/MiniDashboardChatbot";
import { Urls, SettingsUrls } from "./constants";
import VerifyEmailPage from "./pages/dashboard/VerifyEmailPage";
import { AcceptProjectInvite } from "./pages/dashboard/AcceptProjectInvite";
import SettingsPage from "./pages/dashboard/settings/SettingsPage";
import NotFoundPage from "./pages/NotFoundPage";
import { Footer } from "./components/Footer";
import { useSelector } from "react-redux";
import { selectCurrentUser, selectCurrentUserId, selectCurrentUserRole } from "./store/models/User";
import { createSelector } from "reselect";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { MiniDashboardHome } from "./pages/mini-dashboard/MiniDashboardHome";
import { useEffect } from "react";
import { pushTo } from "./store/history";


const selector = createSelector(
    (state) => selectCurrentUserId(state),
    (state) => selectCurrentUserRole(state),
    (userId, userRole) => ({ userId, userRole })
)

export const MiniDashboardAppShell = () => {

    const { userId, userRole } = useSelector(state => selector(state));


    useEffect(() => {
        console.log('user', userRole);
        if (userRole && userRole !== 'partner' && userRole !== 'rep') {
            pushTo(Urls.HOME)
        }
    }, [userRole]);

    return (
        <div className={'AppShell'}>

            <Switch>
                <MiniDashboardNavbar />
            </Switch>

            <div className={'AppShell__Body'}>

                <Switch>
                    <Route path={Urls.LOGIN} component={LoginPage} exact />
                    <Route path={Urls.SIGN_UP} component={SignUpPage} exact />
                    <Route path={Urls.REQUEST_RESET_PASSWORD} component={RequestResetPasswordPage} exact />
                    <Route path={Urls.VERIFY_ACCOUNT} component={VerifyEmailPage} exact />
                    <Route path={Urls.PASSWORD_RESET} component={PasswordResetPage} exact />
                    <Route path={Urls.ACCEPT_INVITE} component={AcceptProjectInvite} exact />

                    {!userId && <Route path={Urls.MINI_DASHBOARD_HOME} component={LoginPage} exact />}
                    {userId && <Route path={Urls.MINI_DASHBOARD_HOME} component={MiniDashboardChatbot} exact />}
                    <LoggedInRoute path={Urls.MINI_DASHBOARD_CHATBOT} component={MiniDashboardChatbot} exact />

                    {/* Settings */}
                    <Route path={'/dashboard/settings'}>
                        <Switch>
                            <LoggedInRoute path={SettingsUrls} component={SettingsPage} exact />
                        </Switch>
                    </Route>

                    <Redirect from={Urls.HOME} to={Urls.MINI_DASHBOARD_HOME} />
                    <Route path={"*"} component={NotFoundPage} />
                </Switch>
            </div>

            <Footer />
        </div>
    )
}